import { useAuth0 } from '@auth0/auth0-react';
import SaveIcon from '@mui/icons-material/Save';
import LoadingButton from '@mui/lab/LoadingButton';
import {
    Alert,
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    styled,
    TextField,
    Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Prompt } from 'react-router';
import { Link } from 'react-router-dom';
import { updateProfile } from '../../redux/ProfileSlice';
import { grades } from '../../utils/grades';
import { skills } from '../../utils/skills';
import jwt_decode from 'jwt-decode';

const LinkColor = styled(Link)(({ theme }) => ({
    color: theme.palette.primary.main,
    '&:hover': {
        color: theme.palette.secondary.main,
        'text-decoration': 'none',
    },
}));

const FormSelection = styled('div')(({ theme }) => ({
    width: '97%',
    margin: '40px auto 0',
    textAlign: 'left',
}));

const CheckBoxGroup = styled(FormGroup)(({ theme }) => ({
    margin: '0 auto 20px',
    width: '95%',
    display: 'grid',
    'grid-gap': '4px',
    'grid-template-rows': 'auto',
    'align-content': 'space-around',
    'justify-content': 'space-between',
    [theme.breakpoints.down('lg')]: {
        'grid-template-columns': 'repeat(2, auto)',
    },
    [theme.breakpoints.up('md')]: {
        'grid-template-columns': 'repeat(3, auto)',
    },
}));

const BookingButton = styled(LoadingButton)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px auto',
    width: '100%',
    maxWidth: '150px',
    borderRadius: '30px',
}));

const ErrorTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette.error.main,
}));

export const Skills = props => {
    const dispatch = useDispatch();
    const { getAccessTokenSilently } = useAuth0();

    const [skillsComplete, setSkillsComplete] = useState(false);

    // Teacher grades and skills
    const [gradeState, setGradeState] = useState({
        grades: [],
        skills: [],
        otherSkills: '',
        touched: false,
    });
    const [loading, setLoading] = useState(false);

    // Returns a Promise that resolves after "ms" Milliseconds
    const timer = ms => new Promise(res => setTimeout(res, ms));

    function handleGradeLevelChange(event) {
        let gradeStateTemp = gradeState.grades;
        console.log(gradeStateTemp);
        const location = gradeStateTemp.indexOf(event.target.name);
        if (location >= 0) {
            gradeStateTemp.splice(location, 1);
        } else {
            gradeStateTemp.push(event.target.name);
        }
        setGradeState({
            ...gradeState,
            grades: gradeStateTemp,
            touched: true,
            error: false,
            errorText: '',
        });
    }

    function handleSkillsChange(event) {
        let gradeSkillTemp = gradeState.skills;
        console.log(gradeSkillTemp, event.target.name);
        const location = gradeSkillTemp.indexOf(event.target.name);
        if (location >= 0) {
            gradeSkillTemp.splice(location, 1);
        } else {
            gradeSkillTemp.push(event.target.name);
        }
        setGradeState({
            ...gradeState,
            skills: gradeSkillTemp,
            touched: true,
            error: false,
            errorText: '',
        });
    }

    function handleOtherSkillChange(event) {
        setGradeState({
            ...gradeState,
            [event.target.id]: event.target.value,
            touched: true,
            error: false,
            errorText: '',
        });
    }

    function nothingSelected() {
        if (gradeState.grades.length == 0) {
            setGradeState({
                ...gradeState,
                errorText: 'At least 1 grade must be selected',
                error: true,
            });
            return true;
        }
        if (gradeState.skills.length == 0 && gradeState.otherSkills == '') {
            setGradeState({
                ...gradeState,
                errorText: 'At least 1 skill must be selected',
                error: true,
            });
            return true;
        }
        return false;
    }

    const updateUserSkills = async () => {
        function resetTouchedItems() {
            setGradeState({
                ...gradeState,
                touched: false,
            });
        }
        if (nothingSelected()) return;
        try {
            setLoading(true);

            async function update() {
                let token = await getAccessTokenSilently({
                    scope: process.env.REACT_APP_scope,
                    ignoreCache:
                        !window.location.href.includes('localhost') &&
                        !window.location.href.includes('app-test'),
                });
                let counter = 0;
                //decode token, determine if has teacher base permission
                const tokenItems = jwt_decode(token);
                while (
                    !tokenItems.permissions.includes('create:teacherProfile')
                ) {
                    await timer(10_000);
                    console.log('Waiting over');
                    token = await getAccessTokenSilently({
                        scope: process.env.REACT_APP_scope,
                        ignoreCache:
                            !window.location.href.includes('localhost') &&
                            !window.location.href.includes('app-test'),
                    });
                    if (counter > 10) {
                        break;
                    }
                    counter++;
                }
                let dynamoData = {
                    token: token,
                    request: {
                        'updateList': [
                            {
                                'key': 'grades',
                                'value': gradeState.grades,
                            },
                            {
                                'key': 'skills',
                                'value': gradeState.skills,
                            },
                            {
                                'key': 'otherSkills',
                                'value': gradeState.otherSkills,
                            },
                        ],
                    },
                };
                const skillsResponse = await dispatch(
                    updateProfile(dynamoData)
                );
                console.log('skills response', JSON.stringify(skillsResponse));

                if (typeof skillsResponse.payload !== 'undefined') {
                    if (skillsResponse.payload.status === 200) {
                        props.setNotif(
                            'success',
                            6000,
                            'Skills information updated'
                        );
                        resetTouchedItems();
                    } else {
                        props.setNotif(
                            'error',
                            0,
                            'Error updating your skills information'
                        );
                    }
                } else {
                    props.setNotif(
                        'error',
                        0,
                        'Error updating your skills information'
                    );
                }
                setLoading(false);
                console.log(dynamoData);
            }
            update();
        } catch (err) {
            console.log('Error occurred updating profile');
            props.setNotif('error', 0, 'Error updating teacher information');
            setLoading(false);
        }
    };

    function handleSkillSubmit(event) {
        console.log('event.target: ' + JSON.stringify(event.target.id));
        event.preventDefault();
        updateUserSkills();
    }

    useEffect(() => {
        function buildGradeState(grades, skills, otherSkills) {
            let resultSet1 = {};
            let resultSet2 = {};
            let resultSet3 = {};
            let countOfSkills = 0;
            console.log('grades', grades);
            if (typeof grades === 'undefined') {
                resultSet1 = { grades: [] };
            } else {
                resultSet1 = {
                    grades: grades.map(item => {
                        return item;
                    }),
                };
                if (grades.length > 0) {
                    countOfSkills = countOfSkills + 1;
                }
            }
            if (typeof skills === 'undefined') {
                resultSet2 = { skills: [] };
            } else {
                resultSet2 = {
                    skills: skills.map(item => {
                        return item;
                    }),
                };
                if (skills.length > 0) {
                    countOfSkills = countOfSkills + 1;
                }
            }
            if (typeof otherSkills === 'undefined') {
                resultSet3 = { otherSkills: [] };
            } else {
                resultSet3 = {
                    otherSkills: otherSkills,
                };
            }

            return Object.assign(resultSet1, resultSet2, resultSet3, {
                countOfSkills: countOfSkills,
            });
        }
        const resultSet = buildGradeState(
            props.grades,
            props.skills,
            props.otherSkills
        );
        console.log('resultset1', resultSet);
        if (resultSet.countOfSkills === 2) {
            setSkillsComplete(true);
        }
        setGradeState({
            ...gradeState,
            grades: resultSet.grades,
            skills: resultSet.skills,
            otherSkills: resultSet.otherSkills,
            touched: false,
            error: false,
            errorText: '',
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    return (
        <div>
            <Prompt
                when={gradeState.touched === true}
                message="There are unsaved changes. Are you sure you want to leave?"
            />

            <FormSelection>
                <Typography variant="h3">Grade Level</Typography>
                <Typography variant="body1">
                    Select the years you are qualified to teach
                </Typography>
                <FormControl
                    required
                    component="fieldset"
                    sx={{ margin: '8px', width: '100%' }}
                >
                    <CheckBoxGroup
                        data-cy="grades-checkboxes"
                        sx={{ gridTemplateColumns: 'repeat(1, auto)' }}
                    >
                        {grades.map((level, index) => (
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={
                                            gradeState.grades &&
                                            (gradeState.grades.indexOf(
                                                level.name
                                            ) >= 0
                                                ? true
                                                : false)
                                        }
                                        onChange={handleGradeLevelChange}
                                        name={level.name}
                                        key={index}
                                    />
                                }
                                label={level.title}
                                style={{
                                    textAlign: 'left',
                                }}
                            />
                        ))}
                    </CheckBoxGroup>
                </FormControl>
            </FormSelection>

            <FormSelection>
                <Typography variant="h3">Specialty</Typography>
                <Typography variant="body1">
                    Select the disciplines you have experience and are qualified
                    to teach
                </Typography>
                <FormControl
                    required
                    component="fieldset"
                    sx={{ margin: '8px', width: '100%' }}
                >
                    <CheckBoxGroup data-cy="skills-checkboxes">
                        {skills.map((skill, index) => (
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={
                                            gradeState.skills &&
                                            (gradeState.skills.indexOf(
                                                skill.name
                                            ) >= 0
                                                ? true
                                                : false)
                                        }
                                        onChange={handleSkillsChange}
                                        name={skill.name}
                                    />
                                }
                                label={skill.title}
                                style={{
                                    textAlign: 'left',
                                }}
                            />
                        ))}
                    </CheckBoxGroup>
                    <TextField
                        label="Other (Please Specify)"
                        id="otherSkills"
                        data-cy="other-skills"
                        multiline
                        rows={4}
                        value={gradeState.otherSkills}
                        onChange={handleOtherSkillChange}
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                    />
                    <ErrorTypography data-cy="skills-error">
                        {gradeState.errorText}
                    </ErrorTypography>
                    <BookingButton
                        id="skillSave"
                        data-cy="save-skills"
                        size="large"
                        color="primary"
                        onClick={handleSkillSubmit}
                        loading={loading}
                        loadingPosition="start"
                        startIcon={<SaveIcon />}
                        variant="outlined"
                        disabled={!gradeState.touched || gradeState.error}
                    >
                        Save Skills
                    </BookingButton>
                    {loading && (
                        <Typography
                            variant="subtitle2"
                            gutterBottom
                            sx={{ textAlign: 'center' }}
                        >
                            Setting up profile can take time, averaging 2
                            minutes, please wait...
                        </Typography>
                    )}
                </FormControl>
            </FormSelection>
            {skillsComplete && props.verified !== 'true' && (
                <Alert severity="success" sx={{ m: 1, alignItems: 'center' }}>
                    Finish verifying your Profile!{' '}
                    <LinkColor to="/profile/documents">
                        <Button variant="outlined" sx={{ m: 1 }} data-cy="next">
                            Next Page
                        </Button>
                    </LinkColor>
                </Alert>
            )}
        </div>
    );
};

export default Skills;
